import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from 'react-redux'
import { END } from 'redux-saga';
import { wrapper } from "@/store";
import getPageProps from "@gcloud-npm/adabyron.page.get-props"
import CmsBlock from "@/bit/components/components.cms/cms-block";
import MetaData from "@/bit/core/core.meta-data";
import Footer from "@/bit/components/components.footer";
import Header from "@/bit/components/components.header";
import FaqsCompo from "@/bit/components/components.cms-block.cms-faqs";
import CmsDetailCardList from "@/bit/components/components.cms-block.cms-detail-card-list";
import CmsTextBlock from "@/bit/components/components.cms-block.text-block";
import CmsAlert from "@/bit/components/components.cms-block.cms-alert";
import CmsModuleCharacteristicsAndSteps from "@/bit/components/components.cms-block.cms-module-characteristics-and-steps"
import { actions as mainActions } from "@/bit/reducers/reducers.main-reducer";
import { getJWTCloudRun } from "@gcloud-npm/node.ssr-process.google-auth";
import Text, {
  TEXT_COLOR,
  TEXT_SIZE,
  TEXT_KIND,
  TEXT_FONT_WEIGHT,
} from "@/bit/components/components.text";
import { LM_ORION_ALIAS } from '@/constants/constant';
import { getStaticProps as getStaticPropsMethod } from "@/utils/page/ssr-pages-handler";
import { actions } from "@/reducers/client-personalization";



const TarifasMovilesClient = ({
  breadcrumbsProps,
  headerProps,
  seoInfo,
  footerProps,
  orionInfo,
  orionAlias
}) => {
  const info = useSelector((state) => state.clientPersonalization);
  const { finalOrionInfo, loadingOrionInfo, pills, title } = info;

  const finalBreadCrumbComposition = {
    ...breadcrumbsProps,
    pills,
  }

  const dispatch = useDispatch();

  useEffect(() => {
    const params = {
      isMigrationPage: false,
      dispatch,
      pills: breadcrumbsProps?.pills
    };
    dispatch(actions.initPersonalization(params));
  }, []);


  return (
    <>
      <MetaData seoInfo={seoInfo} />
      <Header
        {...headerProps}
        {...finalBreadCrumbComposition}
      />
      {finalOrionInfo && (
        <>
          {title && (
            <Text
              className='container ap-title'
              text={title}
              color={TEXT_COLOR.BLUE_DARK}
              size={TEXT_SIZE.TITLE15}
              kind={TEXT_KIND.PARAGRAPH}
              fontType={TEXT_FONT_WEIGHT.BOLD}
            />
          )}

          <main>
            {finalOrionInfo["cms-component-detail-card-list-1"] && (
              <div className={loadingOrionInfo ? 'skeleton' : ''}>
                <CmsBlock
                  alias={orionAlias}
                  orionInfo={finalOrionInfo}
                  blockName="cms-component-detail-card-list-1"
                  Component={CmsDetailCardList}
                />
              </div>
            )}
            {finalOrionInfo["cms-ml-alert-1"] && (
              <div className="container">
                <CmsBlock
                  alias={orionAlias}
                  orionInfo={finalOrionInfo}
                  blockName="cms-ml-alert-1"
                  Component={CmsAlert}
                />
              </div>
            )}

            {finalOrionInfo["cms-module-characteristics-and-steps-1"] && (
              <CmsBlock
                alias={orionAlias}
                orionInfo={finalOrionInfo}
                blockName="cms-module-characteristics-and-steps-1"
                Component={CmsModuleCharacteristicsAndSteps}
              />
            )}
            {finalOrionInfo["cms-component-detail-card-list-2"] && (
              <CmsBlock
                alias={orionAlias}
                orionInfo={finalOrionInfo}
                blockName="cms-component-detail-card-list-2"
                Component={CmsDetailCardList}
              />
            )}

            {finalOrionInfo["cms-component-faq-list-1"] && (
              <CmsBlock
                alias={orionAlias}
                orionInfo={finalOrionInfo}
                blockName="cms-component-faq-list-1"
                Component={FaqsCompo}
              />
            )}

            {finalOrionInfo["cms-component-text-block-list-1"] && (
              <CmsBlock
                alias={orionAlias}
                orionInfo={finalOrionInfo}
                blockName="cms-component-text-block-list-1"
                Component={CmsTextBlock}
              />
            )}
          </main>
          <Footer footerProps={footerProps} />
        </>
      )}
      <style jsx>
        {`
      :global(.ap-title){
        margin-top: 1.5rem;
      }
    `}
      </style>
    </>
  );
}
export default TarifasMovilesClient;

export const getStaticProps = wrapper.getStaticProps(async (data) => {
  const isNotProd = `${process.env.NEXT_PUBLIC_ENV_NAME}` !== "prod";
  const { store } = data;
  const { context } = store.getState().main;
  const orionAlias = "cms-page-tarifas-moviles-1";

  const backendSsrHeaders = await getJWTCloudRun("ssr-backend");

  const [info, LMAInfo] = await Promise.all([
    getStaticPropsMethod(data, "", 0, {
      pathname: "/tarifas-moviles-cms",
      orionCmsAlias: orionAlias,
      seoLocation: "www.movistar.es/tarifas-moviles",
      headerLocation: "/tarifas-moviles",
      revalidate: 60,
      layout: "distri",
    }),
    getPageProps({
      orionCmsAlias: LM_ORION_ALIAS.LMA,
      context,
      headerLocation: '',
      cms: `${process.env.NEXT_PUBLIC_ENV_NAME}` === 'qa_ssr',
      build: true,
      ssrHeaders: backendSsrHeaders,
    })
  ])


  const { orion: orionInfoLMA } = LMAInfo;
  store.dispatch(mainActions.setOrionAlias(orionAlias));

  store.dispatch(
    actions.setOrionInfo({ kind: 'LMA', orionInfo: orionInfoLMA }),
  );
  store.dispatch(
    actions.setOrionInfo({ kind: 'LMC', orionInfo: info.props.orionInfo }),
  );

  store.dispatch(END);
  await store.sagaTask.toPromise();

  const allProps2Return = {
    props: {
      ...info.props,
      orionAlias,
    },
    revalidate: info.revalidate || 300,
  };
  if (isNotProd && allProps2Return.revalidate) {
    delete allProps2Return.revalidate;
  }


  return allProps2Return;
});
